export function renderHitTemplate( hit, { html, components } ) {
  return html`
    <div class="tt-item">
      <a href="${hit.permalink ?? '#'}" style="display:block;padding:8px 0;text-decoration:none;color:inherit">
        <strong>${hit.post_title ?? hit.objectID}</strong>
        ${hit.post_type ? html`<span style="margin-left:8px;opacity:.6;font-size:.85em">${hit.post_type}</span>` : ''}
      </a>
    </div>
  `;
}